import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Login.css";


const API_URL = process.env.REACT_APP_API_URL

export default function Login() {
  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({ username: "", password: "" });
  const [showSignup, setShowSignup] = useState(false);
  const [error, setError] = useState("");

  function handleLogin(e) {
    e.preventDefault();
    setError("");

    if (loginData.username === "" || loginData.password === "") {
      setError("Please fill in all fields");
      return;
    }

    axios.post(`${API_URL}/api/user/login`, loginData)
      .then(function (res) {
        //changed this block so authentication detials are in LocalStorage so protected pages can verify login status and determine role.
        // The backend accesses role inside the user object, so we must access the role using res.data.user.role.
        const role = res.data.user.role;
        const username = res.data.user.username;

        localStorage.setItem("token", res.data.token);
        localStorage.setItem("username", username);
        localStorage.setItem("role", role);

        if (role === "user") {
          navigate("/user-tickets");
        } else {
          navigate("/ticket-manager");
        }
      }).catch(function (err) {
        setError("Invalid username or password");
      });
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <h2 className="login-header">FixTrack Login</h2>
        {error !== "" ? <p className="login-error">{error}</p> : null}
        
        <form onSubmit={handleLogin}>
          <input 
            className="login-input" 
            type="text" 
            placeholder="Username" 
            onChange={function(e) { setLoginData({...loginData, username: e.target.value}) }} 
          />
          <input 
            className="login-input" 
            type="password" 
            placeholder="Password" 
            onChange={function(e) { setLoginData({...loginData, password: e.target.value}) }} 
          />
          <button type="submit" className="btn-black">Login</button>
        </form>

        <p style={{ textAlign: "center", marginTop: "20px", fontSize: "14px" }}>
          Need an account? 
          <button 
            onClick={function() { setShowSignup(true) }} 
            style={{ background: "none", border: "none", fontWeight: "bold", cursor: "pointer", textDecoration: "underline" }}
          >
            Sign Up
          </button>
        </p>
      </div>

      {showSignup === true ? (
        <SignupModal onClose={function() { setShowSignup(false) }} navigate={navigate} />
      ) : null}
    </div>
  );
}

function SignupModal(props) {
  const [formData, setFormData] = useState({ 
    username: "", 
    password: "", 
    confirmPassword: "", 
    firstName: "", 
    lastName: "", 
    role: "user" 
  });
  const [msg, setMsg] = useState("");

  function handleRegister(e) {
    e.preventDefault();

    // Checking for blank fields
    if (formData.firstName === "" || formData.lastName === "" || formData.username === "" || formData.password === "") {
      setMsg("All fields are required");
      return;
    }

    if (formData.password.length < 6) {
      setMsg("Password must be at least 6 characters");
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setMsg("Passwords do not match");
      return;
    }

    axios.post(`${API_URL}/api/user/signup`, formData)
      .then(function (res) {
        localStorage.setItem("token", res.data.token);
        const role = res.data.user.role;

        localStorage.setItem("username", res.data.user.username);
        localStorage.setItem("role", role);
        if ((formData.role || res.data.role) === "user") {
          props.navigate("/user-tickets");
        } else {
          props.navigate("/ticket-manager");
        }
      })
      .catch(function (err) {
        setMsg("Username already in use");
      });
  }

  return (
    <div className="modal-overlay" onClick={props.onClose}>
      <div className="login-card" onClick={function(e) { e.stopPropagation() }}>
        <h3 style={{ marginBottom: "16px" }}>Create Account</h3>
        {msg !== "" ? <p className="login-error">{msg}</p> : null}
        
        <form onSubmit={handleRegister}>
          <div style={{ display: "flex", gap: "10px" }}>
            <input 
              className="login-input" 
              placeholder="First Name" 
              onChange={function(e) { setFormData({...formData, firstName: e.target.value}) }} 
            />
            <input 
              className="login-input" 
              placeholder="Last Name" 
              onChange={function(e) { setFormData({...formData, lastName: e.target.value}) }} 
            />
          </div>
          <input 
            className="login-input" 
            placeholder="Username" 
            onChange={function(e) { setFormData({...formData, username: e.target.value}) }} 
          />
          <input 
            className="login-input" 
            type="password" 
            placeholder="Password (min 6 chars)" 
            onChange={function(e) { setFormData({...formData, password: e.target.value}) }} 
          />
          <input 
            className="login-input" 
            type="password" 
            placeholder="Confirm Password" 
            onChange={function(e) { setFormData({...formData, confirmPassword: e.target.value}) }} 
          />
          
          <select className="login-input" value={formData.role} onChange={function(e) { setFormData({...formData, role: e.target.value}) }}>
            <option value="user">User</option>
            <option value="technician">Technician</option>
            <option value="admin">Admin</option>
          </select>

          <button type="submit" className="btn-black">Register</button>
          <button type="button" onClick={props.onClose} className="btn-gray">Cancel</button>
        </form>
      </div>
    </div>
  );
}
